export default __webpack_public_path__ + "static/media/adp-lyric-img.ce28770c.png";